import { WORKING_DAYS } from '../../constants';

export const DAILY_PROGRESS_RULER_SIZE = 5;
export const WEEKLY_PROGRESS_RULER_SIZE = 25;

export const getSelectedWorkingDay = (todaysDay: string, day: string) => {
  if (WORKING_DAYS.includes(todaysDay)) {
    return todaysDay;
  }

  return 'Friday';
};

export const getColorByDayName = (day: string) => {
  const colorMap: Record<string, string> = {
    Monday: '#0414A2',
    Tuesday: '#3169F6',
    Wednesday: '#83a5fa',
    Thursday: '#c1d2fc',
    Friday: '#5BEAC2',
  };

  return colorMap[day] ?? '#5BEAC2';
};

export const getRulerSize = (
  completedLessons: number | undefined,
  personalGoal: number | undefined | null,
  minRulerSize: number = DAILY_PROGRESS_RULER_SIZE,
  multiple: number = 5
): {
  rulerSize: number;
  rulerInterval: number;
} => {
  if (!completedLessons && !personalGoal) {
    return {
      rulerSize: minRulerSize,
      rulerInterval: 1,
    };
  }

  const value = Math.max(completedLessons ?? 0, personalGoal ?? 0);

  const size = convertToNearestMultiple(value, multiple);
  const rulerSize = Math.max(minRulerSize, size);
  const rulerInterval = getRulerInterval(rulerSize);

  return {
    rulerSize,
    rulerInterval,
  };
};

const convertToNearestMultiple = (value: number, multiple: number): number =>
  Math.ceil(value / multiple) * multiple;

const getRulerInterval = (size: number) => {
  if (size <= 10) {
    return 1;
  } else if (size <= 50) {
    return 5;
  } else if (size <= 100) {
    return 10;
  } else {
    return 25;
  }
};
